import { useEffect, useState } from "react"
import { Link, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import { FooterForm, Banner, } from '../components'
import { tracking } from '../utils/tracking'
import { imgs } from "../assets/imgs"
import { useResizeImg } from '../hooks/useResizeImg'
import { updateTags } from "../utils/funcs"

export const Agenda = () => {
   const imageSource = useResizeImg(imgs.agenda.agendaBannerDesktop, imgs.agenda.agendaBannerMobile)
   const [isLoading, setIsLoading] = useState(true)
   const { day } = useParams()
   const navigate = useNavigate()
   const { search } = useLocation()

   useEffect(() => {
      updateTags("| Agenda")
   }, [])

   useEffect(() => {
      if (!day) navigate('0' + search, {replace: true})
   }, [day])

   return (
      <div className='agenda'>
         <Banner imageSource={imageSource} isLoading={isLoading} setIsLoading={setIsLoading} >
            <section>
               <h1 >Explore Engaging Content</h1>
            </section>
            <section>
               <Link className='btn' to='/registration' onClick={() => tracking(290)} >get your ticket</Link>
            </section>
         </Banner>
         <Outlet />
         <FooterForm />
      </div>
   )
}
